// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"07ca6eec","533":"90dae3f9","638":"d19858c7"}[chunkId] + ".chunk.css";
};